/* eslint semi: 1 */

export default {
  name: 'player-setup-display-resolution',
  components: {},
  mixins: [],
  props: {
    resolutions: {
      type: Array,
      default: () => []
    },
    resolution: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      model: {
        resolution: ''
      }
    };
  },
  watch: {
    resolution: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.model.resolution = newVal;
        }
      }
    },
    resolutions: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal && newVal && newVal.length > 0) {
          // set this.model.resolution only for cases when default resolutions
          // are not resolutions applicable to the player
          if (!this.model.resolution || !newVal.includes(this.model.resolution)) {
            this.model.resolution = `${newVal[0].width}x${newVal[0].height}`;
            this.$emit('change', this.model.resolution);
          }
        }
      }
    }
  },
  mounted () {
    this.model.resolution = this.resolution;
  }
};
